import React from 'react';
import {
  NumericFormat as ReactNumberFormat,
  NumericFormatProps as ReactNumericFormatProps,
} from 'react-number-format';
import {
  TextField as MUITextField,
  TextFieldProps as MUITextFieldProps,
} from '@mui/material';

import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';

type CustomProps = {
  /**
   * style to be applied to the input container
   */
  style?: React.CSSProperties;
  /**
   * if input should be full width of container
   * defaults to true
   */
  fullWidth?: boolean;
  /**
   * autocomplete rule passed down to the input
   * defaults to "off"
   */
  autoComplete?: string;
};

type NumericFormatProps = CustomProps &
  MUITextFieldProps &
  ReactNumericFormatProps;

const inputStyle = {
  fontSize: fonts.md,
  '&:before': {
    borderBottom: `1px solid ${colors.neutral.silver}`,
  },
};

const defaultContainerStyle: React.CSSProperties = {
  width: '100%',
};

export const NumericFormat = (props: NumericFormatProps) => {
  const {
    style,
    fullWidth = true,
    autoComplete = 'off',
    variant = 'standard',
    ...data
  } = props;

  return (
    <div style={{ ...defaultContainerStyle, ...style }}>
      <ReactNumberFormat
        // @ts-ignore
        customInput={MUITextField}
        {...data}
        variant={variant}
        fullWidth={fullWidth}
        autoComplete={autoComplete}
        slotProps={{
          input: { sx: inputStyle },
        }}
      />
    </div>
  );
};

export default NumericFormat;
